import { useEffect } from 'react';
import { usePosStore } from '../store/posStore';

export const usePosSession = () => {
  const {
    sesionActiva,
    sesionLoading,
    fetchSesionActiva,
    abrirSesion,
    cerrarSesion,
    setCajaDialogOpen,
    cajaDialogOpen,
    error,
  } = usePosStore();

  useEffect(() => {
    fetchSesionActiva();
  }, [fetchSesionActiva]);

  return {
    sesionActiva,
    sesionLoading,
    hasSesion: !!sesionActiva,
    abrirSesion,
    cerrarSesion,
    setCajaDialogOpen,
    cajaDialogOpen,
    error,
  };
};
